<template>
    <div v-if="editingCustomer">
        <form @submit.prevent="defaultSave" class="default-form">
            <h3 class="form-section-title">Stammdaten</h3>

            <div class="form-group row">
                <label for="customerName" class="col-sm-2 col-form-label label-form-horizontal">Firmenbezeichnung</label>
                <div class="col-sm-6">
                    <b-form-input id="customerName"
                                  autocomplete="nope"
                                  :state="checkState('customerName')"
                                  type="text"
                                  v-validate="'required'"
                                  name="customerName"
                                  v-model.trim="editingCustomer.name"
                                  ref="customerName"
                    ></b-form-input>
                    <span v-show="errors.has('customerName')" class="error-message">Firmenname ist ein Pflichtfeld</span>
                </div>

                <label for="customerVatId" class="col-sm-1 col-form-label label-form-horizontal">Ust-Id</label>
                <div class="col-sm-3">
                    <b-form-input id="customerVatId"
                                  autocomplete="off"
                                  :state="checkState('customerVatId')"
                                  type="text"
                                  v-validate="'required'"
                                  name="customerVatId"
                                  v-model.trim="editingCustomer.vatId"
                    ></b-form-input>
                    <span v-show="errors.has('customerVatId')" class="error-message">Kunden UstID ist ein Pflichtfeld</span>
                </div>
            </div>

            <div class="form-group row">
                <label for="vatReverseCharge" class="col-sm-2 col-form-label label-form-horizontal">Ust - Umgekehrt</label>
                <div class="col-sm-10">
                <toggle-button id="vatReverseCharge"
                               :value="editingCustomer.vatReverseCharge"
                               :color="'#28a745'"
                               :sync="true"
                               @change="editingCustomer.vatReverseCharge = !editingCustomer.vatReverseCharge"
                               class="col-form-label"
                               ref="vatReverseRef"
                />
                    <small id="emailHelp" class="form-text text-muted">Rechnungen werden ohne UST und mit ensprechenden Hinweis ausgestellt. Die UST ist vom Rechnungsempfänger abzuführen (reverse charge).</small>
                </div>
            </div>
            <h3 class="form-section-title">Adresse</h3>
            <div class="form-group row">
                <label for="inputStreet" class="col-sm-2 col-form-label label-form-horizontal">Straße</label>
                <div class="col-sm-10">

                    <b-form-input id="inputStreet"
                                  autocomplete="off"
                                  :state="checkState('inputStreet')"
                                  type="text"
                                  v-validate="'required'"
                                  name="inputStreet"
                                  v-model.trim="editingCustomer.street"
                    ></b-form-input>
                    <span v-show="errors.has('inputStreet')" class="error-message">Straße ist ein Pflichtfeld</span>
                </div>
            </div>

            <div class="form-group row">
                <label for="inputCity" class="col-sm-2 col-form-label label-form-horizontal">Stadt</label>
                <div class="col-sm-10">

                    <b-form-input id="inputCity"
                                  autocomplete="off"
                                  :state="checkState('inputCity')"
                                  type="text"
                                  v-validate="'required'"
                                  name="inputCity"
                                  v-model.trim="editingCustomer.city"
                    ></b-form-input>
                    <span v-show="errors.has('inputCity')" class="error-message">Stadt ist ein Pflichtfeld</span>
                </div>
            </div>

            <div class="form-group row">

                    <label for="inputZip" class="col-sm-2 col-form-label label-form-horizontal">PLZ</label>
                    <div class="col-sm-4">

                        <b-form-input id="inputZip"
                                      autocomplete="off"
                                      :state="checkState('inputZip')"
                                      type="text"
                                      v-validate="'required'"
                                      name="inputZip"
                                      v-model.trim="editingCustomer.zip"
                        ></b-form-input>
                        <span v-show="errors.has('inputZip')" class="error-message">Postleitzahl ist ein Pflichtfeld</span>
                    </div>

                    <label for="inputZip" class="col-sm-2 col-form-label label-form-horizontal">Land</label>
                    <div class="col-sm-4">
                        <b-form-select
                                v-model.trim="editingCustomer.country"
                                :options="countries"
                                :state="checkState('selectCountry')"
                                name="selectCountry"
                                v-validate="'required'"
                        />
                        <span v-show="errors.has('selectCountry')" class="error-message">Land ist ein Pflichtfeld</span>
                    </div>
            </div>

            <form-section-header    title="Kontaktpersonen"
                                    :dialogRef="$refs.NewContactPersonDialogRef"
                                    >
            </form-section-header>

            <div class="row">
                <div class="col-12" v-if="editingCustomer.contactPersons">
                    <v-client-table :data="editingCustomer.contactPersons" :columns="columns" :options="options" class="invoice-table" >
                    </v-client-table>
                </div>
            </div>

            <div class="form-bottom-buttons d-flex justify-content-end mt-5">
                <b-form-checkbox id="createAnotherID"
                                 v-if="onSaveAndNextCallback"
                                 v-model="createAnother"
                                 value="true"
                                 unchecked-value="false"
                >
                    weitere Erstellen
                </b-form-checkbox>
                <button type="submit" class="btn btn-success"><span v-if="onSaveAndNextCallback">Erstellen</span>
                    <span v-if="!onSaveAndNextCallback">Updaten</span></button>
                <button type="button" class="btn btn-link" @click="$router.go(-1)">Abbrechen</button>
            </div>
        </form>

        <new-contact-person-dialog ref="NewContactPersonDialogRef" @added="onAddContactPerson"></new-contact-person-dialog>
    </div>
</template>

<script>

    import FormSectionHeader from 'components/util/FormSectionHeader';
    import NewContactPersonDialog from "./NewContactPersonDialog";

    export default {
        name: "CustomerForm",
        components: {NewContactPersonDialog, FormSectionHeader},
        props: {

            onSaveCallback: Function,
            onSaveAndNextCallback: Function,
            editingCustomer: {
                type: Object,
                default: function() {

                    return {
                        name: null,
                        vatId: null,
                        street: null,
                        city: null,
                        zip: null,
                        vatReverseCharge: false,
                        country: 'Österreich',
                        contactPersons: [],
                    }
                }
            }
        },
        data: function() {
            return {
                createAnother: false,
                countries: ['Österreich', 'Deutschland'],
                saveError: null,

                columns: ['contactPersonFirstName', 'contactPersonLastName', 'contactPersonEmail', 'contactPersonPhone', 'contactPersonRole'],

                options: {
                    skin: 'table data-table',
                    filterable: false,

                    headings: {
                        contactPersonFirstName: 'Vorname',
                        contactPersonLastName: 'Nachname',
                        contactPersonEmail: 'Email',
                        contactPersonPhone: 'Telefonnummer',
                        contactPersonRole: 'Rolle',
                    },
                }
            }
        },

        watch: {

            'editingCustomer.country': function(newValue) {

                this.vatReverseCharge = newValue !== 'Österreich';
                this.$refs.vatReverseRef.toggled = this.vatReverseCharge;
            }
        },

        mounted: function() {

            this.$refs.customerName.focus();
        },

        methods: {

            onAddContactPerson(contact) {
                this.editingCustomer.contactPersons.push(contact);
            },

            //TODO mixin
            checkState(fieldName) {

                if (!this.errors.has(fieldName)) {
                    return null;
                }

                return false;
            },

            defaultSave() {

                if (this.createAnother) {
                    this.createCustomerAndAddNew();
                } else {
                    this.$validator.validateAll().then(valid => {

                        if (valid) {
                            if (this.onSaveCallback) {
                                this.onSaveCallback(this.editingCustomer);
                            }
                        }
                    });
                }
            },
            createCustomerAndAddNew() {

                this.$validator.validateAll().then(valid => {

                    if (valid) {
                        if (this.onSaveAndNextCallback) {
                            this.onSaveAndNextCallback(this.editingCustomer
                            ).then(result => {

                                this.resetCustomer();
                                this.$refs.customerName.focus();

                                //TODO reset field validation
                            }).catch(e => {
                                this.saveError = "Kunde konnte nicht erstellt werden.";
                                console.error(e);
                            });
                        }
                    }
                });
            },

            resetCustomer() {

                this.editingCustomer.name = null;
                this.editingCustomer.vatId = null;
                this.editingCustomer.street = null;
                this.editingCustomer.city = null;
                this.editingCustomer.zip = null;
                this.editingCustomer.vatReverseCharge = false;
                this.editingCustomer.country = 'Österreich';
                this.editingCustomer.contactPersons = [];

                this.$validator.reset();
            }
        }
    }
</script>

<style scoped>

</style>